/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable check-file/filename-naming-convention */
import * as React from 'react';
import type { SVGProps } from 'react';

export type IllustrationSizeVariants =
  | 'small'
  | 'medium'
  | 'large'
  | 'xlarge'
  | 'xxlarge'
  | 'xxxlarge'
  | 'xxxxlarge';
export type IllustrationProps = {
  width?: number | string;
  height?: number | string;
  size?: IllustrationSizeVariants;
};
const IllustrationSpotJobPosition = ({
  size = 'medium',
  width,
  height,
  ...props
}: IllustrationProps) => {
  let presetWidth: string | undefined;
  let presetHeight: string | undefined;
  const presets = {
    small: '48px',
    medium: '68px',
    large: '92px',
    xlarge: '122px',
    xxlarge: '156px',
    xxxlarge: '194px',
    xxxxlarge: '236px',
  };
  if (size) {
    presetWidth = presets[size];
    presetHeight = presets[size];
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 68 68"
      width={width || presetWidth}
      height={height || presetHeight}
      data-xds="IllustrationSpotJobPosition"
      {...props}
    >
      <path
        fill="#FFFFFE"
        fillRule="evenodd"
        d="M53.351 20.868c0 10.191-8.262 18.453-18.453 18.453s-18.452-8.262-18.452-18.453S24.707 2.416 34.898 2.416s18.453 8.262 18.453 18.452"
        clipRule="evenodd"
      />
      <path
        fill="#27DBA8"
        fillRule="evenodd"
        d="M18.624 61.792a4.987 4.987 0 0 1-4.988 4.987 4.987 4.987 0 1 1 0-9.975 4.99 4.99 0 0 1 4.988 4.988m20.315 0a4.987 4.987 0 0 1-4.988 4.987 4.987 4.987 0 1 1 0-9.975 4.99 4.99 0 0 1 4.988 4.988m20.413 0a4.987 4.987 0 0 1-4.988 4.987 4.987 4.987 0 1 1 0-9.975 4.99 4.99 0 0 1 4.988 4.988"
        clipRule="evenodd"
      />
      <path
        fill="var(--xdlColorIllustrationOutlinePrimary)"
        d="M44.002 10.48c3.022 5.634 5.305 15.324 1.911 17.817-.371.273-.86.515-1.426.719l-.04 3.959-1-.01.038-3.647c-2.952.74-7.058.58-8.26-1.181q.075-.264.154-.528l.158-.525a133 133 0 0 1 1.928-5.814l.01-.027 1.115.04a1.99 1.99 0 0 0 2.062-1.917 1.99 1.99 0 0 0-1.917-2.062l-1.74-.065-.022-.007-.064-.02c-.831-.28-7.428-2.703-6.984-9.275-1.18.798-2.13 2.064-2.872 3.74 1.402.126 2.309.964 2.318 2.609.008 1.295-.357 2.453-1.027 3.7l-.196.353-.381.65a.705.705 0 0 0 .265.975l.09.042 1.435.552-.359.933-1.436-.552a1.705 1.705 0 0 1-.858-2.455l.27-.46.2-.349.089-.163c.598-1.112.914-2.117.908-3.22-.007-1.148-.55-1.597-1.59-1.631h-.123c-.478 1.32-.85 2.847-1.12 4.562-.46 2.932-.57 6.034-.463 8.879l.04.878.021.372 5.913.058.014-.073h2.207l-2.004 1.294-.04 4.215-1-.01.042-4.434-6.055-.058-.048-.558-.036-.524-.022-.404c-.156-3.095-.068-6.535.444-9.79.247-1.57.578-3 1.001-4.273l-.111.026q-.151.036-.271.071l-.202.063-.072.025-.347-.939.093-.032.245-.076.318-.084a7 7 0 0 1 .746-.141c.99-2.446 2.379-4.196 4.223-5.09 1.262-1.395 10.44-2.455 13.828 3.862M31.928 22.04l.931.365c-.326.831-.87 1.407-1.563 1.751a3.54 3.54 0 0 1-1.63.367l-.278-.016.124-.993.036.003c.385.027.86-.036 1.303-.256.422-.21.76-.542.994-1.03zm-.776-6.526a.5.5 0 0 1 .488.415l.007.09-.007.704a.5.5 0 0 1-.993.08l-.007-.09.007-.704a.5.5 0 0 1 .505-.495m-4.363-.042a.5.5 0 0 1 .487.415l.008.09-.007.703a.5.5 0 0 1-.993.08l-.007-.09.007-.704a.5.5 0 0 1 .505-.494"
      />
      <path
        fill="#B7E854"
        fillRule="evenodd"
        d="M47.762 33.134c-2.348-1.61-5.652-2.786-10.284-2.782-5.969.005-10.884 1.842-14.268 4.267-.992.71 2.753 4.83 12.05 4.83 9.294 0 13.038-5.948 12.502-6.315"
        clipRule="evenodd"
      />
      <path
        fill="var(--xdlColorIllustrationOutlinePrimary)"
        d="M35.009 42.524v2.77l20.384-.343v9.889h-2l-.001-7.856-18.383.31v7.545h-2v-7.513l-18.384.31v7.204h-2v-9.17l20.384-.344v-2.802zm-.245-41.303c-10.73 0-19.43 8.699-19.43 19.43s8.7 19.43 19.43 19.43 19.429-8.7 19.429-19.43-8.7-19.43-19.43-19.43m0 2c9.625 0 17.429 7.804 17.429 17.43 0 4.703-1.863 8.972-4.892 12.107l-.43.43a17.37 17.37 0 0 1-12.107 4.892c-9.626 0-17.43-7.803-17.43-17.43 0-9.625 7.804-17.429 17.43-17.429"
      />
    </svg>
  );
};
export default IllustrationSpotJobPosition;
